<template>
  <div class="">
    <div class="container">
      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-10">
          <br />
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12">
                <div class="card">
                  <div class="container">
                    <div class="card-content">
                      <h1
                        class="
                          earth-color
                          heading
                          text-md-center text-lg-center text-sm-center
                        "
                      >
                        Booking confirmed.
                      </h1>
                      <p>
                        Thank you,
                        <span style="text-transform: capitalize">{{
                          singleBooking.booking_details.first_name
                        }}</span>
                      </p>
                      <p><strong>Your booking has been confirmed.</strong></p>
                      <p>
                        Booking reference:
                        <strong>{{ singleBooking.booking_ref_code }}</strong>
                      </p>
                      <p>
                        Total Number of Guests:
                        <b>{{ singleBooking.guest_total }}</b>
                      </p>
                      <br />
                      <p>Dates Selected:</p>
                      <ul>
                        <!-- <li>Booking Checkin Date: <b>{{report_date_format(singleBooking.booking_check_in_date)}}</b></li>
                     <li>Booking Check Out Date: <b>{{report_date_format(singleBooking.booking_check_out_date)}}</b></li> -->
                        <li>
                          Booking Checkin Date:
                          <b>{{ singleBooking.check_in_date }}</b>
                        </li>
                        <li>
                          Booking Check Out Date:
                          <b>{{ singleBooking.check_out_date }}</b>
                        </li>
                      </ul>
                      <br />
                      <p>Conservation Entry Fees:</p>
                      <ul>
                        <li
                          v-for="(guest, key) in singleBooking.guests"
                          v-if="guest.payment_guests > 0"
                          :key="key"
                        >
                          {{ guest.payment_person }}:
                          <b>{{ guest.payment_guests }}</b>
                        </li>
                      </ul>
                      <br />
                      <p v-if="singleBooking.facility_bookings.length > 0">
                        Accommodation Selected:
                      </p>
                      <ul>
                        <li
                          v-for="(
                            facility, key
                          ) in singleBooking.facility_bookings"
                          :key="key"
                        >
                          {{ facility.facility_name }}
                        </li>
                      </ul>
                      <br />
                      <p>Conservation Activities Selected:</p>
                      <ul>
                        <li
                          v-for="(
                            activity, key
                          ) in singleBooking.inventory_bookings"
                          :key="key"
                        >
                          {{ activity.inventory_name }} on
                          {{
                            formated_date(activity.inventory_booking_date)
                          }}
                          for {{ activity.inventory_booking_adults }} adults and
                          {{ activity.inventory_booking_children }} children.
                        </li>
                      </ul>
                      <br />
                      <p>
                        Vehicle Fee: <b>{{ singleBooking.vehicle_count }}</b>
                      </p>
                      <br />
                      <p>
                        Amount:
                        <b
                          >{{ singleBooking.currency }}
                          {{
                            singleBooking.total_cost
                              .toFixed(2)
                              .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
                          }}</b
                        >
                      </p>
                      <p>
                        An email of the confirmation has been
                        <b
                          >sent to
                          {{ singleBooking.booking_details.email_address }}</b
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <br />
    <br />
    <br />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {
    this.$store.dispatch("get_booking", this.$route.params.booking_id);
  },
};
</script>

<style scoped>
p {
  font-size: 140%;
}
li {
  text-decoration: none;
  list-style: none;
}
.activity {
  padding-bottom: 1%;
  padding-top: 1%;
  padding-left: 2%;
  border: 1px solid gray;
}

#side {
  z-index: 100;
  margin-top: -10%;
  position: absolute;
  /**/
  background-color: white;
}

/* Dropdown Button */

/* The container <div> - needed to position the dropdown content */
.dropdown {
  position: relative;
  display: inline-block;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

/* Links inside the dropdown */
.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

/* Change color of dropdown links on hover */
.dropdown-content a:hover {
  background-color: #f1f1f1;
}

/* Show the dropdown menu on hover */
.dropdown:hover .dropdown-content {
  display: block;
}
</style>
